export default (state = {}, action) => {
  if (action.type === 'GREENMILE_ROUTEMONITOR_EVENT_NOTIFICATION_SUCCESS') {
    const { payload: { id, data } } = action;
    return {
      ...state,
      [id]: data,
    };
  }
  return state;
};
